export function isMacOs(): boolean {
  if (typeof navigator === 'undefined') return false

  const userAgentDataPlatform = (navigator as Navigator & { userAgentData?: { platform?: string } })
    .userAgentData?.platform ?? ''
  if (userAgentDataPlatform.toLowerCase().includes('mac')) return true

  const platform = navigator.platform ?? ''
  if (platform.toLowerCase().includes('mac')) return true

  return navigator.userAgent.toLowerCase().includes('mac')
}

export function getPrimaryModifierLabel(): 'Command' | 'Ctrl' {
  return isMacOs() ? 'Command' : 'Ctrl'
}

export function formatShortcut(keys: string[], modifierLabel: string): string[] {
  return keys.map((key) => key.split('Ctrl').join(modifierLabel))
}
